import apiCall from 'apps/catalog/apiCalls/etf-products';
import {
  etfProfileDetail,
  etfProfileEdit,
} from 'apps/catalog/apiCalls/etf-products/etf-profile';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, EditPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './edit-form';
import ETFProfileEditForm from './edit-profile-form';

// apiCall set for the nested ETF profile edit page (reuses the stock list for
// cache invalidation).
const etfProfileApiCall = {
  detail: etfProfileDetail,
  edit: etfProfileEdit,
  list: apiCall.list,
};

export const ETFProductListPage = () => (
  <ListPage
    title="All ETF Products"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={DynamicFilterForm}
  />
);

export const ETFProductEditPage = props => (
  <EditPage
    title="Edit ETF Stock"
    apiCall={apiCall}
    listUrl={`/catalog/products/etfs`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);

export const ETFProfileEditPage = props => (
  <EditPage
    title="Edit ETF Profile"
    apiCall={etfProfileApiCall}
    listUrl={`/catalog/products/etfs`}
    ItemForm={ETFProfileEditForm}
    resourceName="data"
    {...props}
  />
);

export const ETFProductDetailPage = props => (
  <DetailPage
    title="ETF Product"
    apiCall={apiCall}
    listUrl={`/catalog/products/etfs`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ title: 'ETF Product', editEnabled: false }}
    {...props}
  />
);
